module.exports = __webpack_public_path__ + "static/media/i3.2f7b4d14.png";